const postMessage = message => {
  try {
    window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));
  } catch (error) {
    console.error('Could not postMessage to the device');
  }
};

export default {
  postMessage,
};
